import mapboxgl from "mapbox-gl";

export const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1IjoibmVzdGVhcGVhY2giLCJhIjoiY2xid2d1cDZsMTA1djNvdDBsOWtldjVjbSJ9.dlFWnXRPAbPdVPWXs-I_Rg";

export const MAPBOX_STYLE = "mapbox://styles/mapbox/streets-v12";
export const MAPBOX_DEFAULT_BEARING = "220";
export const FLOOR_LAYER_ID = "radar-layer";
export const FLOOR_SOURCE_ID = "radar";
export const DEFAULT_FLOOR_ALL = "***";

let accessTokenSet = false;

export const setMapboxAccessToken = () => {
  if (accessTokenSet) return;
  mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;
  accessTokenSet = true;
};

export const resolveStoreMapEntry = (mapData, retailerId, branchId) => {
  if (!mapData || retailerId == null || branchId == null) return null;
  const direct = mapData?.[retailerId]?.[branchId];
  if (direct) return direct;
  return mapData?.[String(retailerId)]?.[String(branchId)] ?? null;
};

export const parseMapCoordinates = (parsedLocation) => {
  if (!parsedLocation) return null;
  const latVal = Number(parsedLocation.locationLatitude);
  const lngVal = Number(parsedLocation.locationLongitude);
  if (!Number.isFinite(latVal) || !Number.isFinite(lngVal)) return null;
  return { lat: latVal, lng: lngVal };
};

export const getStoreMapCenter = (storeCoordinates) => {
  if (!storeCoordinates) return null;
  const lng = Number(storeCoordinates.lng);
  const lat = Number(storeCoordinates.lat);
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;
  return { lng, lat };
};

export const removeFloorImageLayer = (map) => {
  if (!map) return;
  try {
    if (map.getLayer(FLOOR_LAYER_ID)) map.removeLayer(FLOOR_LAYER_ID);
    if (map.getSource(FLOOR_SOURCE_ID)) map.removeSource(FLOOR_SOURCE_ID);
  } catch {
    // Map may be partially torn down.
  }
};

export const applyFloorImageLayer = (map, storeCoordinates, floor) => {
  if (!map || !storeCoordinates?.url || !storeCoordinates?.coordinates) return false;

  const addLayer = () => {
    removeFloorImageLayer(map);
    map.addSource(FLOOR_SOURCE_ID, {
      type: "image",
      url: `${storeCoordinates.url}/${floor}`,
      coordinates: storeCoordinates.coordinates,
    });
    map.addLayer({
      id: FLOOR_LAYER_ID,
      type: "raster",
      source: FLOOR_SOURCE_ID,
      paint: {
        "raster-fade-duration": 0,
      },
    });
  };

  if (map.isStyleLoaded()) {
    addLayer();
    return true;
  }

  map.once("load", addLayer);
  return true;
};

export const getBranchFloorOptions = (branchMapData) => {
  const floorNumber = branchMapData?.floorNumber;
  if (!floorNumber || typeof floorNumber !== "object") return [];
  return Object.keys(floorNumber).sort((a, b) => Number(a) - Number(b));
};

export const branchHasMultipleFloors = (branchMapData) =>
  getBranchFloorOptions(branchMapData).length > 1;
